var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-inline',{class:_vm.classes,attrs:{"outdated":_vm.attempt.replaced_by_proposal_attempt_id,"current":_vm.attempt.obs,"loading":_vm.loading},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }